import React from "react";

import FormatUtils from "../../utils/formatUtils";
import { SurplusBadge } from "../StatusBadge";

import CarrierSquareIcon from "./CarrierSquareIcon";

import styles from "./HeadsUp.module.scss";

export default function HeadsUp({
  LobDescription,
  SurplusLines,
  CarrierId,
  CarrierName,
  FriendlyCarrierName,
  Rating,
  StatusId,
  Premium,
}) {
  // show Premium when the status is not declined
  const showPremium = StatusId !== 135 && StatusId !== 140;

  return (
    <>
      <div className={styles.lobRow}>
        <span className={styles.lob}>{LobDescription}</span>
        {SurplusLines && <SurplusBadge />}
      </div>

      <div className={styles.carrierRow}>
        <CarrierSquareIcon carrierId={CarrierId} className={styles.carrierLogo} />
        <div className={styles.carrierName}>{FriendlyCarrierName ?? CarrierName}</div>
      </div>

      <div className={styles.premiumRow}>
        <div className={styles.rating}>
          <div className={styles.ratingLabel}>Rating:</div>
          <div className={styles.ratingValue}>{Rating}</div>
        </div>
        {showPremium && (
          <div className={styles.premium}>
            {FormatUtils.formatMoney(Premium)}
          </div>
        )}
      </div>
    </>
  );
}
